<template>
  <div @click="parentBoxClick">
    <ThemePicker style="display: none" :profileTheme="profileTheme" />
    <el-container v-if="createdShow">
      <el-aside>
        <div v-if="!isCollapse" class="logo_nav">
          <img
            height="100%"
            v-if="profileTheme.logo || logoUrlObj.logo"
            :src="`${profileTheme.logo ? profileTheme.logo : logoUrlObj.logo}`"
            alt="fsgo logo"
          />
        </div>
        <div v-else class="logo_sub_nav">
          <img
            height="100%"
            :src="`${profileTheme.smallLogo ? profileTheme.smallLogo : logoUrlObj.logo_sub}`"
            alt="fsgo logo"
          />
        </div>
        <!-- 导航页签 -->
        <el-menu
          style="text-align='right'"
          router
          class="el-menu-vertical-demo"
          background-color="#545c64"
          unique-opened
          @select="getDocumentCategory"
          text-color="#fff"
          :collapse="isCollapse"
          :default-active="activationPath"
        >
          <template v-for="(func, idx) in functions">
            <template v-if="func.functionList.length == 0">
              <el-menu-item
                :index="
                  func.action &&
                  (func.action.indexOf('http://') != -1 || func.action.indexOf('https://') != -1)
                    ? null
                    : func.action
                "
                :key="idx"
              >
                <i :class="func.code"></i>
                <a
                  v-if="
                    func.action &&
                      (func.action.indexOf('http://') != -1 ||
                        func.action.indexOf('https://') != -1)
                  "
                  :href="
                    osg.tenantConfig.exts.md5Token
                      ? getFunctionSign(func.action, osg.tenantConfig.exts.md5Token)
                      : func.action
                  "
                  target="_blank"
                  slot="title"
                  style="color:#fff"
                >
                  {{ func.name }}
                </a>
                <span v-else slot="title">{{ func.name }}</span>
              </el-menu-item>
            </template>
            <template v-else>
              <el-submenu :index="'sub_' + idx" :key="idx">
                <template slot="title">
                  <i :class="func.code"></i>
                  <span>{{ func.name }}</span>
                </template>
                <template v-for="(func2, idx2) in func.functionList">
                  <el-submenu
                    v-if="!func2.action && func2.functionList.length > 0"
                    :index="'sub_' + idx + '_' + idx2"
                    :key="idx2"
                  >
                    <template slot="title">
                      <i :class="func2.code"></i>
                      <span>{{ func2.name }}</span>
                    </template>
                    <template v-for="(func3, idx3) in func2.functionList">
                      <el-menu-item
                        :index="
                          func3.action &&
                          (func3.action.indexOf('http://') != -1 ||
                            func3.action.indexOf('https://') != -1)
                            ? null
                            : func3.action
                        "
                        :key="idx3"
                        style="padding-left: 50px"
                      >
                        <a
                          v-if="
                            func3.action &&
                              (func3.action.indexOf('http://') != -1 ||
                                func3.action.indexOf('https://') != -1)
                          "
                          :href="
                            osg.tenantConfig.exts.md5Token
                              ? getFunctionSign(func3.action, osg.tenantConfig.exts.md5Token)
                              : func3.action
                          "
                          target="_blank"
                          slot="title"
                          style="color:#fff"
                        >
                          {{ func3.name }}
                        </a>
                        <span v-else slot="title">{{ func3.name }}</span>
                      </el-menu-item>
                    </template>
                  </el-submenu>
                  <el-menu-item
                    v-else
                    :index="
                      func2.action &&
                      (func2.action.indexOf('http://') != -1 ||
                        func2.action.indexOf('https://') != -1)
                        ? null
                        : func2.action
                    "
                    :key="idx2"
                    style="padding-left: 50px"
                    @click="tagsChange(func2)"
                  >
                    <a
                      v-if="
                        func2.action &&
                          (func2.action.indexOf('http://') != -1 ||
                            func2.action.indexOf('https://') != -1)
                      "
                      :href="
                        osg.tenantConfig.exts.md5Token
                          ? getFunctionSign(func2.action, osg.tenantConfig.exts.md5Token)
                          : func2.action
                      "
                      target="_blank"
                      slot="title"
                      style="color:#fff;display:block;width:calc(100% + 45px)"
                    >
                      {{ func2.name }}
                    </a>
                    <span v-else slot="title">{{ func2.name }}</span>
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
          </template>
        </el-menu>
        <!-- 到此结束 -->
      </el-aside>
      <el-container class="rightSide">
        <el-header>
          <div class="header_quick">
            <div class="nav-icon">
              <i class="el-icon-s-unfold" v-if="isCollapse" @click="isCollapse = !isCollapse"></i>
              <i class="el-icon-s-fold" v-else @click="isCollapse = !isCollapse"></i>
              <i class="el-icon-menu" @click="navShow = !navShow"></i>
            </div>
            <div class="tab-list">
              <div
                v-for="(tag, index) in tagsList"
                :key="index"
                class="tab-item"
                :class="[
                  tag.path === activationPath ? 'active' : '',
                  rightClickIndex === index ? 'tab-item-hover' : '' // 动态添加 tab-item-hover 类
                ]"
                @mouseover="handleHover(index, true)"
                @mouseleave="handleHover(index, false)"
                @click.stop="chooseTab(tag)"
                @contextmenu.prevent="handleRightClick($event, tag, index)"
              >
                <div v-if="tag.path === activationPath">
                  <i
                    @click.stop="handleRefreshClick(tag)"
                    class="refreshIcon el-icon-refresh-right"
                    style="cursor: pointer;"
                  ></i>
                </div>
                <!-- 占位 -->
                <div v-else></div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :visible-arrow="false"
                  :disabled="showMenu"
                  :content="tag.name"
                  placement="bottom-start"
                >
                  <div class="tabName">{{ tag.name }}</div>
                </el-tooltip>
                <div v-if="tagsList.length > 1">
                  <i @click.stop="closeTab(tag, index)" class="closeIcon  el-icon-close"></i>
                </div>

                <!--  -->
                <div v-else></div>
                <div
                  v-if="showMenu"
                  class="ContextualMenu"
                  :style="{ top: `${menuY}px`, left: `${menuX}px` }"
                  @click.stop="handleMenuClick($event)"
                >
                  <div id="closeCurrent">关闭当前标签</div>
                  <div id="closeRight">关闭右侧标签</div>
                  <div id="closeLeft">关闭左侧标签</div>
                  <div id="closeOthers">关闭其他标签</div>
                  <div id="reload">刷新当前页面</div>
                  <div id="refresh">刷新所有页签</div>
                </div>
              </div>
            </div>
            <div class="navtools">
              <!-- <div class="icon-tool">
                <a
                  target="_blank"
                  href="https://dev.sobot.com/chat/pc/v2/index.html?sysnum=4b51615dfa2c430b9b9e44b439e8c7d2&channelid=2 "
                >
                  去聊
                </a>
              </div> -->
              <div class="icon-tool" v-if="serviceState">
                <!-- v-if="!isIncomingCall" -->
                <!-- <i class="fa fa-phone-volume" v-else></i> -->
                <phoneStripForm
                  ref="callOutStrip"
                  v-if="isIncomingCall"
                  style="
                    position: fixed;
                    top: 0;
                    width: 66%;
                    z-index: 4000;
                    transform: translateX(-50%);
                    left: 50%;
                  "
                  :profileTheme="callOutStripTheme"
                  :callId="callId"
                  :isIncomingCall="isIncomingCall"
                  :options="options"
                  @phoneStripFn="phoneStripFn"
                />
              </div>
              <div class="icon-tool" @click="$router.push({ path: '/Archive' })" title="公告">
                <i class="el-icon-reading"></i>
              </div>
              <div
                class="icon-tool"
                @click="displayWizard({ colName: $route.fullPath, show: true })"
                title="新手向导"
                v-if="guideFunData"
              >
                <i class="el-icon-guide"></i>
              </div>
              <div class="icon-tool" @click="handleFullScreen" title="全屏">
                <i class="el-icon-full-screen"></i>
              </div>
              <div
                class="icon-tool"
                @click="
                  getNotifications();
                  openNotification = true;
                "
                title="站内信"
              >
                <el-badge class="c-icon-dot" :value="unreadNumber" :max="10" v-if="unreadNumber">
                  <i class="el-icon-message-solid c_red c_size_18"></i>
                </el-badge>
                <i v-else class="el-icon-bell"></i>
              </div>
              <div
                class="icon-tool"
                @click="$router.push({ path: '/Personalize' })"
                title="自定义主题"
              >
                <i class="fa fa-palette"></i>
              </div>
              <!-- <div
                class="icon-tool"
                @click="osg.open('', '', '_blank', '/Chat')"
                title="消息中心"
                v-if="tenantId == '8072446751847564486' || tenantId == '1340835581184723420'"
              >
                <el-badge
                  class="c-icon-dot"
                  :value="unreadMessageNumber"
                  :max="10"
                  v-if="unreadMessageNumber"
                >
                  <i class="el-icon-chat-line-square"></i>
                </el-badge>
                <i v-else class="el-icon-chat-line-square"></i>
              </div> -->
              <el-divider direction="vertical"></el-divider>
              <div class="user-tool">
                <el-dropdown
                  class="demo"
                  ref="dropdown"
                  trigger="click"
                  placement="bottom"
                  :hide-on-click="dropdownHideShow"
                  @command="dropdownCommand"
                >
                  <span class="el-dropdown-link">
                    <img
                      v-if="(user && user.avatar) || (profile.avatar && profile.avatar.length > 50)"
                      class="photo"
                      :src="user.avatar || profile.avatar"
                    />
                    <img v-else class="photo" src="../assets/user.png" />
                    {{ user.name || profile.name || '请登陆账号' }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      command="true"
                      @click.native="$router.push({ path: '/Preferences' })"
                    >
                      个人资料
                    </el-dropdown-item>
                    <el-dropdown-item
                      command="false"
                      @click.native.prevent="
                        changePassword.showCancelButton = true;
                        changePassword.show = true;
                      "
                    >
                      修改密码
                    </el-dropdown-item>
                    <el-dropdown-item
                      command="false"
                      divided
                      @click.native.prevent="isAccountPopover = false"
                    >
                      <el-popover
                        placement="left"
                        width="300"
                        trigger="hover"
                        ref="isAccountPopover"
                      >
                        <el-table ref="table" :data="accountsDropdownData">
                          <el-table-column>
                            <template slot="header">
                              <el-link
                                type="primary"
                                href="javascript:;"
                                @click.native="$router.push({ path: '/Account' })"
                              >
                                点击查看所有账号
                              </el-link>
                            </template>
                            <div
                              slot-scope="scope"
                              @click="loginChange(scope.row)"
                              class="c-pointer"
                            >
                              <p>{{ scope.row.name || profile.name }}：{{ scope.row.phone }}</p>
                              <div style="color: #888">
                                所属租户：{{ scope.row.tenantName || profile.name }}
                              </div>
                            </div>
                          </el-table-column>
                        </el-table>
                        <div slot="reference">
                          <div>
                            <div style="font-weight: 700">当前租户</div>
                            <div style="font-size: 12px; color: #999">
                              {{ user.tenantName || profile.name || '请选择租户' }}
                            </div>
                          </div>
                        </div>
                      </el-popover>
                    </el-dropdown-item>
                    <el-dropdown-item command="false" divided>
                      <el-popover
                        placement="left"
                        width="85"
                        trigger="hover"
                        ref="isRolePopoverPopover"
                      >
                        <el-table ref="table" :data="roleList" style="width: 100%">
                          <el-table-column>
                            <template slot="header">
                              <span style="font-size: 15px">选择角色</span>
                            </template>
                            <template slot-scope="scope">
                              <el-link
                                :underline="false"
                                style="width: 100%"
                                @click.stop="
                                  changeRole({
                                    ids: scope.row._id,
                                    data: scope.row
                                  })
                                "
                              >
                                {{ scope.row.name }}
                              </el-link>
                            </template>
                          </el-table-column>
                        </el-table>
                        <div slot="reference">
                          <div>
                            <div style="font-weight: 700">当前角色</div>
                            <div style="font-size: 12px; color: #999">
                              {{ actionRole.name || '默认全部角色' }}
                            </div>
                          </div>
                        </div>
                      </el-popover>
                    </el-dropdown-item>
                    <el-dropdown-item command="false" divided v-if="options.operations.length > 0">
                      <el-popover
                        placement="left"
                        width="85"
                        trigger="hover"
                        ref="operationPopover"
                      >
                        <el-table ref="table" :data="options.operations" style="width: 100%">
                          <el-table-column>
                            <template slot="header">
                              <span style="font-size: 15px">选择城市运营</span>
                            </template>
                            <template slot-scope="scope">
                              <el-link
                                :underline="false"
                                style="width: 100%"
                                @click.stop="changeCurrentOperationId(scope.row._id)"
                              >
                                {{ scope.row.label }}
                              </el-link>
                            </template>
                          </el-table-column>
                        </el-table>
                        <div slot="reference">
                          <div>
                            <div style="font-weight: 700">城市运营数据权限</div>
                            <div style="font-size: 12px; color: #999">
                              {{
                                user.currentOperationId
                                  ? osg.codelabel('operations', user.currentOperationId, this)
                                  : '全部'
                              }}
                            </div>
                          </div>
                        </div>
                      </el-popover>
                    </el-dropdown-item>
                    <el-dropdown-item command="true" divided @click.native="logout">
                      退出登录
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </el-header>
        <el-main v-if="userRole">
          <div>
            <all-keep-alive :include="cachedViews" :max="15">
              <router-view
                v-if="isRouterAlive"
                :key="$route.fullPath"
                :serviceState="serviceState"
                :profileTheme="profileTheme"
                :callId="callId"
                @delCallId="delCallId"
                @objectDataFn="objectDataFn"
              ></router-view>
            </all-keep-alive>
          </div>
        </el-main>
      </el-container>
      <el-drawer
        size="500px"
        :visible.sync="openNotification"
        :withHeader="false"
        :with-header="false"
        custom-class="notice-drawer"
      >
        <div class="notification">
          <div class="notification-header">
            <h4>通知</h4>
            <el-button
              type="text"
              size="medium"
              icon="el-icon-plus"
              @click.native="newNotification"
            >
              发送站内信
            </el-button>
          </div>
          <div class="c-p-10">
            <el-button round size="mini" @click="getNotifications()">全部</el-button>
          </div>
          <div class="notification-content" v-infinite-scroll="load">
            <div
              class="notification-item"
              :class="item.state != 10 ? 'unread' : ''"
              v-for="(item, i) in fpi.data"
              :key="i"
            >
              <div class="icon">
                <i class="el-icon-chat-dot-square"></i>
              </div>
              <div class="content">
                <p>{{ item.title }}</p>
                <p>
                  <span>{{ item.content }}</span>
                  <span class="c-m-l-10" v-if="item.exts && item.exts.route">
                    <el-link style="margin-top:-3px;" type="primary" @click="route(item)">
                      点击跳转
                    </el-link>
                  </span>
                </p>
              </div>
              <div class="fun">
                <p>{{ item.createTime }}</p>
                <p class="handle c-hidden">
                  <span v-show="true" class="read c-pointer" @click="doRead(item._id)">
                    标记为已读
                  </span>
                  <!-- <span v-show="true" class="remove c-pointer" @click="doRemove(item._id)">
                    删除
                  </span> -->
                </p>
              </div>
            </div>
          </div>
          <div class="notification-footer">
            <el-switch
              style="display: block"
              v-model="onlyUnread"
              inactive-value="all"
              active-value="unread"
              active-color="#13ce66"
              active-text="仅显示未读"
              @change="getNotifications()"
            ></el-switch>
            <div @click="doReadAll" class="c-pointer c-hover-color">
              <i class="el-icon-brush c-m-r-5"></i>
              <span>全部标记为已读</span>
            </div>
          </div>
        </div>
      </el-drawer>
      <el-dialog title="发送站内信" :visible.sync="openNewNotification">
        <el-form
          :model="noticeFormData"
          :rules="rules"
          ref="noticeFormData"
          label-width="90px"
          label-position="left"
          hide-required-asterisk:true
        >
          <el-form-item label="接收类型">
            <el-select v-model="noticeFormData.receiveType" @change="noticeFormData.receiveId = []">
              <el-option
                v-for="item in options.receiveType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="接收人" prop="receiveId" v-if="noticeFormData.receiveType">
            <el-select
              multiple
              v-model="noticeFormData.receiveId"
              v-if="noticeFormData.receiveType == 'personal'"
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in options.users"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              multiple
              v-model="noticeFormData.receiveId"
              v-else-if="noticeFormData.receiveType == 'role'"
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in options.roles"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select multiple v-model="noticeFormData.receiveId" v-else @change="$forceUpdate()">
              <el-option
                v-for="item in options.all"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--<el-form-item label="标题">
            <el-input v-model="noticeFormData.title"></el-input>
          </el-form-item>-->
          <!--<el-form-item label="描述" prop="description">
            <el-input v-model="noticeFormData.description"></el-input>
          </el-form-item>-->
          <el-form-item label="内容" prop="content">
            <el-input type="textarea" :rows="3" v-model="noticeFormData.content"></el-input>
          </el-form-item>
          <!--<el-form-item label="参数">
            <el-input v-model="noticeFormData.param"></el-input>
          </el-form-item>-->
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="saveNotification">确 定</el-button>
          <el-button @click="initNotification">取 消</el-button>
        </div>
      </el-dialog>
    </el-container>

    <phoneStrip
      style="
        position: fixed;
        top: 0;
        width: 66%;
        z-index: 4000;
        transform: translateX(-50%);
        left: 50%;
      "
      :profileTheme="profileTheme"
      :objectData="objectData"
      :options="objectData.options"
      @phoneStripFn="phoneStripFn"
      v-if="serviceState && objectData.exhaleOpen && objectData.callId && objectData.formData.phone"
    ></phoneStrip>
    <template v-if="wizardStepData.show">
      <wizardSteps
        :colName="wizardStepData.colName"
        :show="wizardStepData.show"
        @closeWizard="() => (wizardStepData.show = false)"
      ></wizardSteps>
    </template>
    <el-dialog title="企业公告" width="40%" :visible.sync="dialogTableVisible" :show-close="false">
      <el-table :data="gridData" width="auto">
        <el-table-column property="title" label="标题"></el-table-column>
        <el-table-column width="100px">
          <template slot-scope="scope">
            <el-dropdown-item @click.native="archiveDetail(scope.row)">查看</el-dropdown-item>
          </template>
        </el-table-column>
      </el-table>
      <div slot="title" style="display: flex;justify-content: space-between;align-items: center;">
        <h3>企业公告</h3>
        <span class="c_gray c_pointer" @click="dialogTableVisible = false">全部关闭</span>
      </div>
    </el-dialog>
    <el-drawer
      :visible.sync="navShow"
      :modal="false"
      direction="ltr"
      class="nav-drawer"
      :class="`${subFunctions.length > 0 ? 'nav-drawer-500' : 'nav-drawer-auto'}`"
    >
      <el-menu router class="el-menu-vertical-demo" @select="getDocumentCategory">
        <template v-for="(func, idx) in functions">
          <template v-if="func.functionList.length == 0">
            <el-menu-item
              :index="
                func.action &&
                (func.action.indexOf('http://') != -1 || func.action.indexOf('https://') != -1)
                  ? null
                  : func.action
              "
              :key="idx"
            >
              <i :class="func.code"></i>
              <a
                v-if="
                  func.action &&
                    (func.action.indexOf('http://') != -1 || func.action.indexOf('https://') != -1)
                "
                :href="
                  osg.tenantConfig.exts.md5Token
                    ? getFunctionSign(func.action, osg.tenantConfig.exts.md5Token)
                    : func.action
                "
                target="_blank"
                slot="title"
                style="color:#fff"
              >
                {{ func.name }}
              </a>
              <span v-else slot="title">{{ func.name }}</span>
            </el-menu-item>
          </template>
          <template v-else>
            <el-submenu :index="'sub_' + idx" :key="idx" @click.native="getInFunctions(func, idx)">
              <template slot="title">
                <i :class="func.code"></i>
                <span>{{ func.name }}</span>
              </template>
              <template v-for="(func2, idx2) in func.functionList">
                <el-menu-item
                  :index="
                    func2.action &&
                    (func2.action.indexOf('http://') != -1 ||
                      func2.action.indexOf('https://') != -1)
                      ? null
                      : func2.action
                  "
                  :key="idx2"
                  style="padding-left: 50px"
                  @click="subFunctions = func2.functionList"
                >
                  <a
                    v-if="
                      func2.action &&
                        (func2.action.indexOf('http://') != -1 ||
                          func2.action.indexOf('https://') != -1)
                    "
                    :href="
                      osg.tenantConfig.exts.md5Token
                        ? getFunctionSign(func2.action, osg.tenantConfig.exts.md5Token)
                        : func2.action
                    "
                    target="_blank"
                    slot="title"
                  >
                    {{ func2.name }}
                  </a>
                  <span v-else slot="title">{{ func2.name }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </template>
      </el-menu>

      <el-menu
        style="text-align='right'"
        router
        class="el-menu-vertical-demo submenu"
        @select="getDocumentCategory"
        :default-active="subFunctionsIndex"
        v-if="subFunctions.length > 0"
      >
        <template>
          <el-menu-item
            v-for="(func, idx) in subFunctions"
            :index="
              func.action &&
              (func.action.indexOf('http://') != -1 || func.action.indexOf('https://') != -1)
                ? null
                : func.action
            "
            :key="idx"
            class="submenu-item"
            :class="func.logoImageUrl ? 'submenu-item-image' : ''"
            style="padding-left: 0 !important;"
          >
            <!-- <i :class="func.code"></i> -->
            <!-- <img fit="cover"  :title="func.name"  :src="func.logoImageUrl" alt=""> -->
            <!-- <el-image fit="cover" style="width: 158px"  :title="func.name"  :src="func.logoImageUrl" alt=""></el-image> -->
            <a
              v-if="
                func.action &&
                  (func.action.indexOf('http://') != -1 || func.action.indexOf('https://') != -1)
              "
              :href="
                osg.tenantConfig.exts.md5Token
                  ? getFunctionSign(func.action, osg.tenantConfig.exts.md5Token)
                  : func.action
              "
              target="_blank"
              slot="title"
              style="width:100%;height:60px"
            >
              <el-image
                fit="cover"
                style="width: 100%; height: 60px;"
                :title="func.name"
                :src="func.logoImageUrl"
              ></el-image>
            </a>
            <el-image
              v-else
              fit="cover"
              style="width: 100%; height: 60px;"
              :title="func.name"
              :src="func.logoImageUrl"
            ></el-image>
          </el-menu-item>
        </template>
      </el-menu>
    </el-drawer>
    <!-- 修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="changePassword.show"
      width="550px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :model="changePassword.formData"
        label-width="100px"
        label-position="left"
        ref="changePassword"
        :rules="changePassword.rules"
      >
        <el-form-item label="原密码" prop="oldPasswd">
          <el-input
            v-model="changePassword.formData.oldPasswd"
            placeholder="请输入当前密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPasswd"
          :rules="{
            required: true,
            pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/,
            trigger: ['change', 'blur'],
            message: !changePassword.formData.newPasswd
              ? '请输入新密码'
              : changePassword.formData.oldPasswd == changePassword.formData.newPasswd
              ? '新密码不能与原密码相同'
              : '新密码必须由8-16位大小写字母、数字、特殊字符组成'
          }"
        >
          <el-input
            v-model="changePassword.formData.newPasswd"
            placeholder="请输入8-16位大小写字母、数字、特殊字符"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="newPasswd2" :rules="changePassword.rules.newPasswd2">
          <el-input
            v-model="changePassword.formData.newPasswd2"
            placeholder="请再次输入新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="c-flex c-flex-between">
        <el-button v-if="changePassword.showCancelButton" @click="changePassword.show = false">
          取消
        </el-button>
        <el-button v-else @click="logout">登录其他账号</el-button>
        <el-button type="primary" @click="passwordSave()">确认修改</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="800px"
      @close="closeRichTextPicker"
      :title="richTextDialog.title"
      :visible.sync="richTextDialog.status"
      close-on-click-modal
    >
      <div
        class="rich-text-container"
        style="width: 100%; max-height: 700px;overflow-y: auto;"
        v-html="richTextContent"
      ></div>
    </el-dialog>
  </div>
</template>
<script>
// import preferences from "../views/Preferences";
// import Personalize from "../views/Personalize";
import ThemePicker from '@/components/ThemePicker.vue';
import logo from '@/assets/logo_nav.png';
import logo_sub from '@/assets/logo_sub_nav.png';

import { allKeepAlive } from 'all-keep-alive';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'NavMenu',
  inject: ['reload'], //注入app里刷新页面方法
  components: {
    // preferences
    ThemePicker,
    allKeepAlive,
    //呼入表单
    phoneStripForm: resolve => require(['@/components/phoneStripForm.vue'], resolve),
    //呼出表单
    phoneStrip: resolve => require(['@/components/phoneStrip.vue'], resolve),
    //新手向导弹窗
    wizardSteps: resolve => require(['@/components/wizardSteps.vue'], resolve)
  },
  data() {
    window.navData = this;
    window.$this = window.$this || this;
    var oldPasswdValidator = (rule, value, callback) => {
      if (!value && value !== '0') {
        callback(new Error('请输入当前密码'));
      } else if (this.changePassword.formData.oldPasswd == this.changePassword.formData.newPasswd) {
        callback(new Error('原密码与新密码不能相同!'));
      } else {
        callback();
      }
    };
    var confirmPwd = (rule, value, callback) => {
      if (!value && value !== '0') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changePassword.formData.newPasswd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userRole: false, //角色标识
      gridData: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      upload: {
        downloadUrl: this.osg.downloadUrl
      },
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '120px',
      isShow: false,
      outerVisible: false,
      innerVisible: false,
      functions: [],
      subFunctions: [],
      subFunctionsIndex: '',
      inFunctionsIndex: '',
      isCollapse: false, //导航折叠箭头
      editableTabsValue: '2', //当前选择标签
      editableTabs: [], //已加载标签
      fullscreen: false, //当前是否全屏
      profile: {}, //当前租户信息，右上角
      profileTheme: {}, //当前租户配置及主题
      callOutStripTheme: {}, //电话条采用单独的配置
      openNotification: false, //通知窗口
      onlyUnread: 'all',
      openNewNotification: false, //新建站内信对话框
      notificationTimer: null, //获取站内信定时器
      lastNotificationId: '', //最新的站内信id
      messageTimer: null, //获取消息中心消息定时器
      windowFocus: true,
      titleShine: false,
      unreadNumber: 0,
      unreadMessageNumber: 0,
      fpi: {
        rows: 0
      },
      noticeFormData: { receiveId: [] },
      rules: this.$util.rules,
      options: {
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },
        codecfg_callResult: { codeId: 'callResult' },
        cascadeCode_channel: { codeId: 'channel' },
        codecfg_leadDiscrepancy: { codeId: 'leadDiscrepancy' },
        codecfg_sex: { codeId: 'SEX' },
        //工单
        codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        //通话记录
        cascadeCode_LEADSTATUS: { codeId: 'LEADSTATUS' },
        codecfg_callMode: { codeId: 'callMode' },
        codecfg_altertState: { codeId: 'altertState' },
        receiveType: [
          { label: '人员', value: 'personal' },
          { label: '角色', value: 'role' },
          { label: '全部', value: 'all' }
        ],
        users: [],
        roles: [],
        //售后类型细分
        cascadeCode_afterSaleType: { codeId: 'afterSaleType' },
        codecfg_IS: { codeId: 'IS' }, // 是否
        noticeData: [], //公告数据
        //NPS问题库
        codecfg_questionBank: {
          codeId: 'questionBank'
        },
        codecfg_NPSreply: { codeId: 'NPSreply' }, //NPS答案
        operations: [] //查看城市运营数据权限
      },
      //自定义主题
      customTheme: {
        logoUrl: ''
      },
      //本地图片
      logoUrlObj: {
        logo: logo,
        logo_sub: logo_sub
      },
      createdShow: false,
      accountsDropdownData: [], //账户列表
      // 下拉菜单显示隐藏
      dropdownHideShow: false,
      entityID: '',
      isAccountPopover: false, //右上角选择多账户窗口的显示隐藏
      user: {}, //user
      entity: {},
      roleList: [], //查询选择角色列表
      actionRole: {}, //当前角色
      fsgoUnionId: '',
      test: 'test',
      serviceState: '',
      isIncomingCall: '', //来电,也用来标识没有来电
      callId: '', //给通话记录id
      objectData: {}, //业务页面数据
      isRouterAlive: true, //控制视图是否显示
      //新手向导弹窗
      wizardStepData: {
        colName: '',
        show: false
      },
      //新手向导菜单数据
      guideFunData: {},
      navShow: false,
      changePassword: {
        show: false,
        showCancelButton: false,
        formData: {},
        rules: {
          oldPasswd: [
            {
              required: true,
              validator: oldPasswdValidator,
              trigger: ['change', 'blur']
            }
          ],
          newPasswd2: [
            {
              required: true,
              validator: confirmPwd,
              trigger: ['change', 'blur']
            }
          ]
        },
        captcha: ''
      },
      showMenu: false,
      menuX: 0,
      menuY: 0,
      rightClickTag: null, // 记录右键点击的 tag
      rightClickIndex: null // 记录右键点击的 index
    };
  },
  computed: {
    ...mapState(['cachedViews', 'tagsList', 'activationPath', 'richTextContent', 'richTextDialog'])
  },
  async mounted() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude } = position.coords;
          sessionStorage.setItem('gpsPoint', JSON.stringify({ latitude, longitude }));
        },
        error => {
          console.error('获取位置失败:', error.message);
        }
      );
    } else {
      console.log('浏览器不支持地理位置服务');
    }

    // 单点登录时拿到token后先获取下entity
    if (this.$route.query.token) {
      this.$util.cookie.set(
        this.$util.cookieRelative.token,
        this.$route.query.token,
        this.$util.cookieRelative.tokenExpires
      );
      await this.getAccount();
    }

    if (!sessionStorage['entity']) {
      let cookie = this.$util.cookie.get(this.$util.cookieRelative.token);
      if (cookie) {
        await this.getAccount();
      } else {
        this.$router.push('/');
      }
    } else {
      // 判断是否需要修改密码
      if (JSON.parse(sessionStorage['entity']).reset == '1') {
        this.changePassword.showCancelButton = false;
        this.changePassword.show = true;
        return;
      }
    }

    let entity = JSON.parse(sessionStorage.getItem('entity'));
    let roleChangeData = JSON.parse(localStorage.getItem('roleChangeData'));
    this.entityID = entity.entityID;
    this.fsgoUnionId = entity.fsgoUnionId;
    //根据浏览器缓存获取当前选择的角色，如果有使用当前角色的功能菜单
    if (roleChangeData && roleChangeData.tenantId == entity.tenantId && roleChangeData.roleData) {
      this.changeRole({
        data: roleChangeData.roleData,
        ids: roleChangeData.roleData._id
      });
    } else {
      this.getFunctions();
    }

    this.entity = JSON.parse(sessionStorage['entity']);
    this.tenantId = this.entity.tenantId;
    //根据浏览器缓存获取当前选择的账号，如果没有则调接口查询
    if (JSON.parse(sessionStorage.getItem('loginAccount'))) {
      this.user = JSON.parse(sessionStorage.getItem('loginAccount'));
      if (this.user.operationIds && this.user.operationIds.length > 0) {
        this.getOperations(); // 获取当前登录人城市运营查看权限
      } else {
        this.options.operations = [];
      }
      this.getMyRegion(); // 获取当前登录人可见行政区划
      this.getTenantConfig(); //个性化配置
      // 读取登录用户外呼权限
      // if (this.actionRole._id == '812337714845629049') {
      //   this.serviceState = this.actionRole._id;
      // }

      // if (sessionStorage['userData']) {
      //   this.serviceState = JSON.parse(sessionStorage['userData']).serviceState || '';
      // }
      // this.callAuthority(); //查询是否有客服的呼入呼出权限
    } else {
      await this.loginChange({ _id: this.entity.entityID }, 'init');
    }

    this.getProfile().then(() => {
      this.createdShow = true;
    });

    this.getAccountsData();

    this.rolePersonInTenant();

    this.getDocumentCategory(); //查询新手向导

    // //获取公告
    this.getNotice();

    // //获取站内信
    this.getNotifications(() => {
      this.getUnreadNumber(); // 更新未读消息数量
      // 每5分钟查询一次，是否有未收到的新消息 发送通知
      clearInterval(this.notificationTimer);
      this.notificationTimer = setInterval(() => {
        this.getNewNotifications();
      }, 1000 * 60 * 5);
    });

    // //标签页标题新消息提醒
    // window.onfocus = () => {
    //   this.windowFocus = true;
    //   this.titleShine = false;
    // };
    // window.onblur = () => {
    //   this.windowFocus = false;
    // };
    // this.notifyInTitle();

    // 查询消息中心数量
    // this.getNewMessageCount();
    // clearInterval(this.messageTimer);
    // if (this.$route.name != 'Chat') {
    //   this.messageTimer = setInterval(() => {
    //     this.getNewMessageCount();
    //   }, 15000);
    // }

    this.getConfig();
    //刷新页面的时候 看看有没有当前不要清楚
    //
  },
  created() {
    this.logoUrlObj = {
      logo: logo,
      logo_sub: logo_sub
    };
  },
  //提供方法给子页面
  provide() {
    return {
      logout: this.logout,
      getProfile: this.getProfile,
      viewReload: this.viewReload, //刷新页面
      displayWizard: this.displayWizard, //显示向导弹窗
      getNavNewMessageCount: this.getNewMessageCount
    };
  },
  methods: {
    ...mapMutations([
      'SetActivationPath',
      'SetActivationName',
      'SetTagsList',
      'SetCachedViews',
      'updateCachedViews',
      'SetRichTextDialog',
      'SetRichTextContent'
    ]),
    //递归查找当前路径所匹配的菜单
    findFunctionByActionUrl(functions, targetUrl) {
      for (const func of functions) {
        // 检查当前节点的 actionUrl 是否匹配
        if (func.action === targetUrl) {
          return func;
        }
        // 如果有子节点，递归查找
        if (func.functionList && func.functionList.length > 0) {
          const result = this.findFunctionByActionUrl(func.functionList, targetUrl);
          if (result) {
            return result; // 如果在子节点中找到，直接返回
          }
        }
      }
      return null; // 如果没有找到，返回 null
    },
    //生成uuid（18位），随机数（5位）+时间戳（13位）
    randomUUid() {
      let num = '';
      for (var i = 0; i < 5; i++) {
        num += Math.floor(Math.random() * 10);
      }
      return num + new Date().valueOf();
    },
    //刷新页面
    viewReload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
      });
    },
    //显示新手向导弹窗
    displayWizard(wizardStepData = {}) {
      this.wizardStepData = wizardStepData;
    },
    //同一浏览器新建标签页，如果有token不需要重新登录
    getAccount() {
      return new Promise(resolve => {
        this.osg.ajax(
          '/account/getOneself.do',
          {},
          res => {
            sessionStorage['entity'] = JSON.stringify(res);
            this.osg.customize.bizId = res.entityID;
            this.osg.customize.entity = res;
            resolve();
          },
          {
            noload: true
          }
        );
      });
    },
    //获取当前租户信息
    getProfile() {
      return new Promise(resolve => {
        this.osg.ajax(
          `tenant/find/${this.tenantId}.do`,
          {},
          res => {
            if (res.entity) this.profile = res.entity;
          },
          {
            noload: true
          }
        );
        resolve();
      });
    },
    //获取当前租户个性化配置
    getTenantConfig() {
      return new Promise(resolve => {
        this.osg.ajax(
          'biz/tenantConfig/findById.do',
          {
            tenantId: this.user.tenantId
          },
          res => {
            this.osg.tenantConfig = res.entity;
            if (this.osg.tenantConfig.uploadMode == 1 || this.osg.tenantConfig.uploadMode == 2) {
              this.osg.downloadUrl = '/';
            } else {
              this.osg.downloadUrl = 'https://pub.fsgo365.cn/';
              // this.osg.downloadUrl = 'http://qiniu.sicoma.com.cn/'; // 仕高玛
            }
            this.profileTheme = res.entity ? res.entity : {};
            //设置浏览器icon图标/title
            document.querySelector('#titleBroswer').innerHTML = !this.profileTheme.browserTitle
              ? '修链科技丨数字化赋能房屋维修'
              : this.profileTheme.browserTitle;
            document.querySelector('#iconTitleBroswer').href = !this.profileTheme.browserIcon
              ? './favicon.ico'
              : this.profileTheme.browserIcon;
            //设置主题色（按钮...）
            this.$util.customizeMenuChange(this.profileTheme.menuBarBgColor);
            resolve();
          },
          {
            noload: true
          }
        );
      });
    },
    getConfig() {
      this.osg.ajax('/config/query.do', {}, res => {
        if (res.cascadeArea) {
          this.osg.ajax('~' + this.osg.downloadUrl + res.cascadeArea, {}, res => {
            if (this.osg.areaList.length == 0) {
              res.areaList.map(item => {
                this.osg.areaList.push(item);
              });
              window.$this.areaShow = false;
              window.$this.$nextTick(() => {
                window.$this.$refs &&
                  window.$this.$refs.table &&
                  window.$this.$refs.table.$refs.table &&
                  window.$this.$refs.table.$refs.table.doLayout();
                window.$this.areaShow = true;
              });
            }
          });
        }
        if (res.areaListWithStreet) {
          this.osg.ajax('~' + this.osg.downloadUrl + res.areaListWithStreet, {}, res => {
            this.osg.areaObj = res;
            window.$this.areaShow = false;
            window.$this.$nextTick(() => {
              window.$this.$refs && window.$this.$refs.table && window.$this.$refs.table.doLayout();
              window.$this.areaShow = true;
            });
          });
        }
      });
    },
    //获取登录用户菜单权限
    getFunctions() {
      if (this.functions.length > 0) return;
      this.osg.ajax(
        'login/main.do',
        {},
        res => {
          // 强制刷新页面重新赋值,自定义列功能需要
          let entity = JSON.parse(sessionStorage['entity']);
          this.osg.customize.bizId = entity.entityID;
          this.osg.customize.entity = entity;

          if (res.data) {
            sessionStorage['currentRole'] = JSON.stringify(res.data.currentRole);
            this.userRole = true;
            this.functions = res.data.currentFun.functionList;
            if (this.functions.length == 0) {
              this.osg.alert('当前登录用户未配置菜单权限！');
              return;
            }
            this.actionRole = res.data.currentRole;
            //缓存按钮权限
            let buttons = {};
            let list = res.data.currentFun.functionList;
            for (let list1 of list) {
              for (let list2 of list1.functionList) {
                if (!list2.action) {
                  break;
                }
                if (!buttons[list2.action.slice(1, list2.action.length)]) {
                  buttons[list2.action.slice(1, list2.action.length)] = [];
                }
                for (let button of list2.buttonList) {
                  buttons[list2.action.slice(1, list2.action.length)].push(button.code); //将按钮放到菜单下的数组中
                }
                // 如果将详情页配置到列表页下一级 则会出现三级
                if (list2.functionList.length > 0) {
                  for (let list3 of list2.functionList) {
                    buttons[list3.action.slice(1, list3.action.length)] = [];
                    for (let button3 of list3.buttonList) {
                      buttons[list3.action.slice(1, list3.action.length)].push(button3.code);
                    }
                  }
                }
              }
            }
            sessionStorage['buttons'] = JSON.stringify(buttons);
            //登录后跳转到第一个菜单
            if (this.$route.path == '/NavMenu') {
              if (this.functions.length > 0) {
                var path = this.functions[0].functionList[0].action;
                this.$router.push(path).then(() => {
                  this.tagsChange(this.functions[0].functionList[0]);
                });
              }
            } else {
              // 第一个页签
              let matchedFunction = this.findFunctionByActionUrl(
                this.functions,
                this.$route.fullPath
              );
              if (matchedFunction) {
                this.tagsChange(matchedFunction);
              }
            }
          } else if (res.data && res.data.length) {
            this.$router.push({ path: '/Account' });
          }
          // 客服外呼权限
          if (this.actionRole._id == '812337714845629049') {
            this.serviceState = this.actionRole._id;
            this.callAuthority();
          }
        },
        {
          noload: true
        }
      );
    },
    tabClick(tab) {
      this.$router.push({ name: tab.name });
    },
    //注销登录
    logout() {
      this.osg.ajax('logout', {}, () => {
        this.notificationTimer && clearInterval(this.notificationTimer);
        this.$util.cookie.deleteCookie(this.$util.cookieRelative.token);
        this.$util.cookie.deleteCookie('SERVERID');
        this.$router.push('/');
        sessionStorage.clear();
        sessionStorage.removeItem('loginAccount');
        if (sessionStorage['userData']) sessionStorage.removeItem('userData');
      });
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      // 判断是否已经是全屏
      // 如果是全屏，退出
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        // 否则，进入全屏
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      // 改变当前全屏状态
      this.fullscreen = !this.fullscreen;
    },
    // 消息中心
    getNewMessageCount() {
      this.osg.ajax(
        '/chatMessage/getNewMessageCount.do',
        {},
        res => {
          this.unreadMessageNumber = res.data.newCount;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    //通知
    initNotification() {
      this.openNewNotification = false;
      this.noticeFormData = { receiveId: [] };
    },
    //滚动加载消息
    load() {
      if (!this.fpi.rows) {
        this.fpi.rows = 20;
      } else {
        this.fpi.rows += 20;
      }
      this.getNotifications();
    },
    // 获取全部站内信
    getNotifications(callback) {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 10,
        sortField: 'createTime',
        sortOrder: 'desc',
        status: this.onlyUnread
      };
      this.osg.ajax(
        'notification/query.do',
        params,
        res => {
          this.fpi = res;
          if (res.data.length > 0) {
            this.lastNotificationId = res.data[0]._id;
          }
          if (callback) callback();
        },
        { noload: true }
      );
    },
    // 获取并更新未读消息数量
    getUnreadNumber() {
      this.osg.ajax(
        'notification/query.do',
        {
          page: 1,
          rows: 1,
          status: 'unread'
        },
        res => {
          this.unreadNumber = res.total;
        },
        { noload: true }
      );
    },
    // 查询是否有登录后新收到的未读消息
    getNewNotifications() {
      this.osg.ajax(
        '/notification/queryNew.do',
        { lastId: this.lastNotificationId || null },
        res => {
          if (res.data && res.data.length > 0) {
            if (!this.windowFocus) this.titleShine = true;
            this.lastNotificationId = res.data[res.data.length - 1]._id; //跟新最新的消息id，下次查询新消息用到
            this.requestPermission(res.data); //发送通知
            this.getUnreadNumber(); //更新未读数量
          }
        },
        { noload: true }
      );
    },
    // 判断浏览器是否支持Web Notification，然后判断发送桌面通知还是页面通知
    requestPermission(data) {
      if (!('Notification' in window)) {
        // 当前浏览器不支持桌面通知
        // 发送网页内通知
        this.notifyInPage(data);
      } else if (Notification.permission === 'granted') {
        // 允许
        // 发送桌面通知
        this.notifyOnDesktop(data);
      } else if (Notification.permission !== 'denied') {
        // 未授权过，重新发起请求，让用户同意使用通知
        Notification.requestPermission(permission => {
          if (permission === 'granted') {
            // 用户同意使用通知
            // 发送桌面通知
            this.notifyOnDesktop(data);
          } else {
            // 用户拒绝
            // 发送网页内通知
            this.notifyInPage(data);
          }
        });
      } else {
        // denied 用户已经明确的拒绝了显示通知的权限
        this.notifyInPage(data);
      }
    },
    // 发送桌面通知
    notifyOnDesktop(data) {
      for (let item of data) {
        let n = new Notification(item.content, {
          icon: 'https://t7.baidu.com/it/u=1595072465,3644073269&fm=193&f=GIF'
        });
        //点击当前消息提示框后，跳转到当前页面
        n.onclick = function() {
          window.focus();
        };
      }
    },
    // 发送网页内通知
    notifyInPage(data) {
      for (let item of data) {
        setTimeout(() => {
          this.$notify.info({
            title: '站内信',
            message: item.content
          });
        }, 500);
      }
    },
    // 未停留在当前标签页时，在标签页标题提醒新消息
    notifyInTitle() {
      var titleInit = document.title;
      setInterval(() => {
        var title = document.title;
        if (!this.windowFocus && this.titleShine) {
          if (/新/.test(title) == false) {
            document.title = '【您有新消息】';
          } else {
            document.title = '【　　　　　】';
          }
        } else {
          document.title = titleInit;
        }
      }, 1000);
    },
    //新建站内信
    newNotification() {
      this.getUsers();
      this.getRoles();
      this.options.all = [{ label: '全部', value: this.tenantId }];
      this.openNewNotification = true;
    },
    saveNotification() {
      var pass = false;
      this.$refs['noticeFormData'].validate(valid => {
        if (valid) pass = true;
      });
      if (!pass) return;
      var params = this.noticeFormData;
      params.tenantId = this.tenantId;
      params.channel = '2';
      this.osg.ajax('notification/upsert.do', params, () => {
        this.initNotification();
        this.getNotifications();
        this.osg.toast('站内信发送成功！');
      });
    },
    doRead(id) {
      this.osg.ajax(`notification/disable/${id}.do`, null, () => {
        this.getNotifications();
        this.getUnreadNumber();
      });
    },
    doRemove(id) {
      this.osg.ajax(`notification/remove/${id}.do`, null, () => {
        this.getNotifications();
        this.getUnreadNumber();
      });
    },
    doReadAll() {
      this.osg.ajax('notification/disableBatch.do', null, () => {
        this.getNotifications();
        this.getUnreadNumber();
      });
    },
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        { _all: '1', notFilterOrgId: '1', notFilterBelongTo: '1' },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.roles = res.data;
        },
        { noload: true }
      );
    },
    getUsers() {
      this.osg.ajax(
        'user/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
        },
        { noload: true }
      );
    },
    logoUrl(val) {
      this.customTheme.logoUrl = val;
    },
    //个人切换菜单
    dropdownCommand(commandVal) {
      if (commandVal == 'true') {
        this.$refs.dropdown.visible = false;
      } else {
        this.$refs.dropdown.visible = true;
      }
    },
    //查询账户列表
    getAccountsData() {
      let params = {
        fsgoUnionId: this.fsgoUnionId
      };
      this.osg.ajax(
        'account/getUserListByFsgoUnionId.do',
        params,
        res => {
          this.accountsDropdownData = res.data;
        },
        {
          noload: true
        }
      );
    },
    //闭水更新系统弹窗
    bsSystemUpdatePopup(tenantId) {
      if (tenantId == '4551453470943235290' && window.location.hostname.indexOf('bishui') == -1) {
        this.isShow = true;
        this.dialogTableVisible = true;
        var params = {
          'is:type|integer#and': 3,
          'is:isTop|integer#and': 1,
          sortField: 'isTop,updateTime',
          sortOrder: 'desc'
        };
        this.osg.ajax('document/query.do', params, res => {
          this.gridData = res.data;
        });
      }
    },
    //点击登陆
    loginChange(row, isInit) {
      return new Promise(resove => {
        this.isAccountPopover = true;
        this.osg.ajax('login/changeAccount.do', { userId: row._id }, async res => {
          sessionStorage.setItem('loginAccount', JSON.stringify(res.data.user));
          // 如果当前登录人维护了查看城市运营数据权限
          if (res.data.user.operationIds && res.data.user.operationIds.length > 0) {
            this.getOperations(); // 获取当前登录人城市运营查看权限
          } else {
            this.options.operations = [];
          }
          this.getMyRegion(); // 获取当前登录人可见行政区划
          resove();
          if (res.data && res.data.user) this.bsSystemUpdatePopup(res.data.user.tenantId); //闭水更新系统弹窗

          //将客户是否有外呼权限放入缓存
          if (res.data.serviceState) {
            window.sessionStorage['userData'] = JSON.stringify({
              serviceState: res.data.serviceState
            });
          } else {
            window.sessionStorage.removeItem('userData');
          }

          // 读取登录用户外呼权限
          if (sessionStorage['userData']) {
            this.serviceState = JSON.parse(sessionStorage['userData']).serviceState || '';
          }
          this.callAuthority(); //查询是否有客服的呼入呼出权限
          this.user = res.data.user || {};
          this.getTenantConfig(); //个性化配置
          this.$message({
            message: '登陆成功!',
            type: 'success'
          });
          //第一次加载首页不需要刷新页面，只有后面切换账户才会刷新页面
          if (!isInit) {
            await this.getAccount();
            this.reload();
          }
          this.$forceUpdate();
          // this.$router.push('/');
        });
      });
    },
    //查询当前租户下的所有角色列表
    rolePersonInTenant() {
      this.osg.ajax(
        'role/queryRoleByPersonInTenant.do',
        null,
        res => {
          if (res.data && res.data.length) {
            this.roleList = res.data;
            // if(!this.actionRole.name) this.actionRole.name = this.roleList[0].name;
          }
          //   this.roleList.unshift({
          //     name: '默认全部角色',
          //     _id: res.data
          //       .map(item => item._id)
          //       .join(',')
          //       .split(',')
          //   });
        },
        {
          noload: true
        }
      );
    },
    //切换角色
    changeRole(roleData) {
      if (this.$refs['isRolePopoverPopover']) {
        this.$refs['isRolePopoverPopover'].doClose();
      } else if (this.$refs['isAccountPopover']) {
        this.$refs['isAccountPopover'].doClose();
      }
      if (this.entity.accountType == 'c') {
        this.osg.toast('当前账户为超级管理员！', 'warning');
        return;
      }
      this.actionRole = roleData.data;
      // 缓存当前角色
      sessionStorage['currentRole'] = JSON.stringify(this.actionRole);
      this.userRole = true; //等获取完角色权限再来显示页面
      if (this.actionRole._id == '812337714845629049') {
        this.serviceState = this.actionRole._id;
        this.callAuthority();
      }
      window.$this && window.$this.$forceUpdate(); // 可以刷新流程处理详情页底部按钮
      let roleIds = Array.isArray(roleData.ids) ? roleData.ids.join(',') : roleData.ids;
      this.osg.ajax('function/changeRole.do', { roleIds: roleIds }, res => {
        if (res.entity) {
          this.functions = res.entity.functionList;
          if (this.functions.length == 0) {
            this.osg.alert('当前登录用户未配置菜单权限！');
          }
          //缓存按钮权限
          let buttons = {};
          let list = res.entity.functionList;
          for (let list1 of list) {
            for (let list2 of list1.functionList) {
              if (!list2.action) {
                break;
              }
              buttons[list2.action.slice(1, list2.action.length)] = [];
              for (let button of list2.buttonList) {
                buttons[list2.action.slice(1, list2.action.length)].push(button.code); //将按钮放到菜单下的数组中
              }
              // 如果将详情页配置到列表页下一级 则会出现三级
              if (list2.functionList.length > 0) {
                for (let list3 of list2.functionList) {
                  buttons[list3.action.slice(1, list3.action.length)] = [];
                  for (let button3 of list3.buttonList) {
                    buttons[list3.action.slice(1, list3.action.length)].push(button3.code);
                  }
                }
              }
            }
          }
          sessionStorage['buttons'] = JSON.stringify(buttons);

          // 流程处理详情页右侧标签页区域动态展示
          if (this.$route.name == 'Flow') {
            window.$this && window.$this.isTabsShow();
          }

          //切换角色后跳转菜单第一个
          if (this.functions.length > 0) {
            var path = this.functions[0].functionList[0].action;
            if (
              this.$route.name != 'Flow' &&
              this.$route.name != 'Chat' &&
              this.$route.name != 'extFormDetail'
            ) {
              this.$router.push(path);
            }
          }
          res.entity.tenantId = this.entity.tenantId;
          res.entity.roleData = roleData.data;
          localStorage.setItem('roleChangeData', JSON.stringify(res.entity));

          // 第一个页签
          let matchedFunction = this.findFunctionByActionUrl(this.functions, this.$route.fullPath);
          if (matchedFunction) {
            this.tagsChange(matchedFunction);
          }
        }
      });
    },
    //400呼入，查询是否有来电
    queryHasCall(params, callback) {
      params = params || {};
      this.osg.ajax(
        'basic/sobot/queryHasCall.do',
        params,
        res => {
          if (callback) callback(res);
        },
        { noload: true }
      );
    },
    // //400呼入，查询是否有来电6.0
    // queryHasCall(params, callback) {
    //   params = params || {};
    //   this.osg.ajax(
    //     '/basic/sobot/agentAnswerCall.do',
    //     params,
    //     res => {
    //       if (callback) callback(res);
    //     },
    //     { noload: true }
    //   );
    // },
    //删除呼入
    delCallId(val) {
      if (val) {
        this.callId = '';
        this.isIncomingCall = '';
        this.queryHasCall({ del: '1' });
      }
    },
    //业务模块对象子组件传参
    objectDataFn(data) {
      this.objectData.exhaleOpen = false;
      this.$nextTick(() => {
        this.objectData = data;
        this.objectData.exhaleOpen = true;
      });
    },
    //电话条子组件传参
    phoneStripFn(data) {
      //objectData.exhaleOpen && objectData.callId && objectData.formData.phone
      //呼入挂断
      if (!data.isHangUp) this.objectData = {};
    },
    // 查询是否有客服的呼入呼出权限
    callAuthority() {
      let that = this;
      if (this.serviceState) {
        clearInterval(timer);
        const timer = setInterval(() => {
          //如果呼入表单被打开了，则不轮询调用查看是否来电
          if (that && that.$refs && that.$refs.callOutStrip) {
            if (that.$refs.callOutStrip.isHandle) {
              return;
            }
          }
          // 400呼入，查询是否有来电
          this.queryHasCall({}, res => {
            //当返回值有data，说明来电
            if (res.data) {
              this.callId = res.data.callId;
              this.isIncomingCall = res.data.phone;
              if (res.data.level) this.callOutStripTheme.themeColor = res.data.level;
            } else {
              this.callId = '';
              this.isIncomingCall = '';
              this.callOutStripTheme.themeColor = '';
            }
          });
        }, 3000);

        // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
        this.$once('hook:beforeDestroy', () => {
          clearInterval(timer);
        });
      }
    },
    // 获取公告
    getNotice() {
      if (sessionStorage.getItem('readNotice')) return;
      var params = {
        'is:type|integer#and': this.type || '3',
        'is:exts.chooseApplet|string#and': 4, // 4.PC端公告
        sortField: 'isTop,updateTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('document/query.do', params, res => {
        if (res.data && res.data.length) {
          this.noticeData = res.data[0];
          if (this.noticeData.isTop) {
            if (this.noticeData.content) {
              this.noticeData.content = this.noticeData.content.replace(
                /<img /g,
                '<img style="max-width:100%" '
              );
            }
            this.$alert(
              `<div class="ql-editor">${this.noticeData.content}</div>`,
              this.noticeData.title,
              {
                dangerouslyUseHTMLString: true
              }
            );
            sessionStorage['readNotice'] = '1';
          }
        }
      });
    },
    //查询新手菜单
    getDocumentCategory() {
      this.osg.ajax(
        'documentCategory/query.do',
        { type: 7, _all: 1 },
        res => {
          if (res.entity && res.entity.childrens) {
            this.guideFunData = res.entity.childrens.find(
              item => (item.exts && item.exts.action) == this.$route.fullPath
            );
          }
        },
        {
          noload: true
        }
      );
    },
    // 公告跳转到页面
    route(item) {
      let path = item.exts.route + item.formDataId;
      this.$router.push({
        path
      });
    },
    archiveDetail(row) {
      row.content = row.content.replace(/<img /g, '<img style="max-width:100%" ');
      this.$alert('<div class="ql-editor">' + row.content + '</div>', row.title, {
        dangerouslyUseHTMLString: true
      });
      this.gridData = this.gridData.filter(item => item._id != row._id);
      if (this.gridData.length <= 0) {
        this.isShow = false;
        this.dialogTableVisible = false;
      }
    },
    // 获取签名后的url
    getFunctionSign(url, SECURITY_Token) {
      let uid = this.entity.accountName;
      let t = new Date().getTime();
      if (!window.md5) return url;
      if (url.indexOf('?') != -1) {
        return `${url}&uid=${uid}&t=${t}&sign=${window.md5(uid + '+' + t + '+' + SECURITY_Token)}`;
      } else {
        return `${url}?uid=${uid}&t=${t}&sign=${window.md5(uid + '+' + t + '+' + SECURITY_Token)}`;
      }
    },
    getInFunctions(func, idx) {
      if (
        func.functionList.some(item => {
          return item.logoImageUrl;
        })
      ) {
        this.subFunctions = func.functionList;
      } else {
        this.subFunctions = [];
      }
    },
    //修改密码
    passwordSave() {
      if (this.osg.validate('changePassword', this)) {
        this.osg.ajax(
          'account/changePasswd.do',
          {
            oldPasswd: this.$util.Base64.encode(this.changePassword.formData.oldPasswd),
            newPasswd: this.$util.Base64.encode(this.changePassword.formData.newPasswd),
            newPasswd2: this.$util.Base64.encode(this.changePassword.formData.newPasswd2)
          },
          () => {
            this.changePassword.show = false;
            this.osg.alert('密码修改成功，请重新登录！', () => {
              this.logout();
            });
          }
        );
      }
    },
    // 获取当前登录人城市运营查看权限
    getOperations() {
      this.osg.ajax('/basic/operation/myOperation.do', {}, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        res.data.unshift({
          label: '全部',
          value: ''
        });
        this.options.operations = res.data;
      });
    },
    // 修改当前登录人城市运营查看权限
    changeCurrentOperationId(operationId) {
      this.$refs['operationPopover'] && this.$refs['operationPopover'].doClose();
      this.osg.ajax('/user/changeOperationId.do', { operationId }, res => {
        // 更新缓存中的user，刷新页面后会获取
        sessionStorage.setItem('loginAccount', JSON.stringify(res.data));
        // 刷新当前页面
        window.location.reload();
      });
    },
    // 获取当前登录人可见行政区划
    getMyRegion() {
      this.osg.ajax('/basic/operation/myRegion.do', {}, res => {
        this.osg.myRegions = res.data;
      });
    },
    //标签切换的时候
    chooseTab(tag) {
      // this.activationPath = tag.path;
      this.SetActivationPath(tag.path);
      this.SetActivationName(tag.name);
      this.$router.push({ path: tag.path });
      this.parentBoxClick();
    },
    //鼠标右键
    handleRightClick(e, tag, index) {
      this.showMenu = true;
      this.menuX = e.clientX; // 鼠标点击的 X 坐标
      this.menuY = e.clientY; // 鼠标点击的 Y 坐标
      this.rightClickTag = tag; // 记录右键点击的 tag
      this.rightClickIndex = index; // 记录右键点击的 index
    },
    //制造鼠标悬停效果
    handleHover(index, isHovered) {
      if (this.showMenu) return;
      this.rightClickIndex = isHovered ? index : null;
    },
    //菜单栏点击的时候
    tagsChange(e) {
      this.SetCachedViews(e);
    },
    //标签页刷新事件
    handleRefreshClick(tag) {
      this.updateCachedViews(tag.path);
      this.viewReload();
    },
    closeTab(tag, index, direction = 'single') {
      // 如果只剩下一个标签，直接返回
      if (this.tagsList.length === 1) return;
      // 根据方向（关闭左侧、右侧、单个标签）更新标签列表
      this.SetTagsList({ tag, index, direction });
      // 等待标签列表更新完成
      setTimeout(() => {
        // 判断当前激活的标签路径是否与关闭的标签路径一致
        if (this.$route.fullPath === tag.path) {
          let nextIndex = -1;
          // 根据关闭方向选择下一个标签
          if (direction === 'single') {
            // 如果是关闭单个标签，选择下一个标签
            nextIndex = index < this.tagsList.length ? index : this.tagsList.length - 1;
          } else if (direction === 'left') {
            // 如果是关闭左侧标签，选择左边的标签
            nextIndex = Math.max(0, index - 1);
          } else if (direction === 'right') {
            // 如果是关闭右侧标签，选择右边的标签
            nextIndex = Math.min(this.tagsList.length - 1, index + 1);
          }
          // 确保选择有效的标签索引
          const nextTag = this.tagsList[nextIndex];
          if (nextTag) {
            // 跳转到下一个标签
            this.$router.push({ path: nextTag.path });
            this.SetActivationPath(nextTag.path);
          }
        } else {
          // 如果当前标签不是关闭的标签，则选择原来的标签
          if (!this.cachedViews.includes(this.$route.fullPath)) {
            this.chooseTab(tag);
          }
        }
      }, 0);
    },
    //鼠标右键菜单事件
    handleMenuClick(event) {
      if (event.target.tagName === 'DIV') {
        const actionId = event.target.id; // 获取点击的 div 的 id
        this.showMenu = false;
        // 根据 id 执行对应的操作
        switch (actionId) {
          case 'closeCurrent':
            // 处理关闭当前标签的逻辑
            this.closeTab(this.rightClickTag, this.rightClickIndex, 'single');
            return;
          case 'closeRight':
            // 处理关闭右侧标签的逻辑
            this.closeTab(this.rightClickTag, this.rightClickIndex, 'right');
            return;
          case 'closeLeft':
            // 处理关闭左侧标签的逻辑
            this.closeTab(this.rightClickTag, this.rightClickIndex, 'left');
            return;
          case 'closeOthers':
            // 处理关闭其他标签的逻辑
            this.closeTab(this.rightClickTag, this.rightClickIndex, 'others');
            return;
          case 'reload':
            // 处理重新加载的逻辑
            this.handleRefreshClick(this.rightClickTag);
            return;
          case 'refresh':
            // 处理刷新整个页面的逻辑
            window.location.reload(); // 使用浏览器的原生方法刷新整个页面
            return;
        }
      }
    },
    //取消监听 采用最外层父盒子的点击事件 来关闭自定义右侧菜单
    parentBoxClick() {
      this.showMenu = false;
      this.rightClickIndex = null;
    },
    //修改富文本 弹窗显示状态
    closeRichTextPicker() {
      this.SetRichTextDialog({ status: false, title: '' });
    }
  }
};
</script>
<style lang="scss">
.showHideBtn {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  overflow: hidden;
  vertical-align: middle;
  margin: 0;
  cursor: pointer;
}
@-webkit-keyframes rotate-forever {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
.loading > .showHideBtn {
  -webkit-animation: 1s ease-in-out infinite rotate-forever;
}
.showHideBtn:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  top: 4px;
  left: 4px;
  border: solid rgba(0, 0, 0, 0);
  border-width: 10px 6px;
  border-top-color: #aaa;
  transition-property: all;
  transition-duration: 0.2s;
}
.hide-sub .showHideBtn:after {
  transform-origin: 50% 20%;
  transform: rotate(-90deg);
}
.hide-sub > ul {
  display: none;
}

/* 滚动条优化更细圆角 */
/* ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track-piece {
  background-color: rgba(241, 241, 241);
  -webkit-border-radius: 2px;
}

::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  /* background-color: #1bbc9b; */
/* background-color: rgb(169, 169, 169);
  -webkit-border-radius: 2px;
} */

/* ::-webkit-scrollbar-thumb:horizontal {
  width: 5px;
  background-color: rgb(169, 169, 169);
  -webkit-border-radius: 2px;
} */

#app {
  text-align: left; /*导航菜单左对齐，不居中*/
}
/*取消侧边栏ElementUI指定的默认宽度，否则收起时也是该宽度*/
.el-aside {
  width: auto !important;
}
.el-menu {
  border-right: 0;
}
/*导航菜单展开*/
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  height: calc(100vh - 50px);
}
/*导航菜单收起，默认宽度64px*/
.el-menu--collapse {
  height: calc(100vh - 50px);
}
/*解决ElementUI禁用的菜单栏，滚动展示时背景色白色
.el-menu-item.is-disabled {
  opacity: 1;
  cursor: auto;
  background: rgb(84, 92, 100) !important;
}*/
/*
.el-menu-item {
  padding-left: 60px !important;
}
*/
/* 屏幕右侧(除左侧导航区域) */
.rightSide {
  height: 100vh;
}
.el-header {
  /* height: 85px !important; */
  height: 50px !important;
  padding: 0;
}
.el-header .header_quick {
  height: 50px !important;
  padding: 0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;

  max-width: 100%;
  background-color: #ffffff;
}
.header_quick .navtools {
  padding: 0 20px;
  display: flex;
  align-items: center;
  min-width: fit-content;
}
.navtools .icon-tool {
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 2px;
  cursor: pointer;
}
.navtools .c-icon-dot .el-badge__content {
  top: 5px;
  right: 5px;
}
.navtools .icon-tool:hover {
  background-color: #f2f2f2;
}
.navtools .user-tool {
  cursor: pointer;
}
.navtools .user-tool > div {
  padding: 2px 10px;
}
.navtools .user-tool:hover {
  background-color: #f2f2f2;
}
.notice-drawer .el-drawer__header {
  display: none;
}
.notification {
  height: 100vh;
  display: flex;
  flex-direction: column;
  color: #333;
}
.notification-header {
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #f7f8fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dfe3eb;
}
.notification-footer {
  font-size: 13px;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #f7f8fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.notification-footer .el-switch span {
  font-size: 13px;
  font-weight: normal;
}
.notification-content {
  flex: 1;
  overflow-y: auto;
}
.notification-item {
  display: flex;
  padding: 10px;
  position: relative;
  font-size: 14px;
  color: #333;
  padding: 15px 30px 15px 15px;
}
.notification-item .handle {
  margin-top: 7px;
}
.notification-item.unread:before {
  content: '';
  position: absolute;
  top: 20px;
  right: 15px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: #f94e4e;
}
.notification-item:hover {
  background-color: #f7f8fa;
}
.notification-item.unread:hover .handle {
  visibility: visible !important;
}
.notification-item .read:hover {
  color: #409eff;
}
.notification-item .remove:hover {
  color: #f56c6c;
}
.notification-item .icon {
  width: 50px;
}

.notification-item i {
  font-size: 18px;
  color: #fff;
  background: #409eff;
  border-radius: 50%;
  padding: 5px;
}
.notification-item .content {
  flex: 1;
}
.notification-item .fun {
  width: 100px;
  margin-left: 20px;
  font-size: 12px;
  color: #999;
  text-align: right;
}
.el-dropdown-link {
  display: inline-block;
}
/*标签栏*/
.header_tag {
  display: none;
}
.header_tag .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}
.header_tag .el-tabs__header {
  margin: 0;
}
.header_tag .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0;
}
/*标签*/

.header_tag .el-tabs__item {
  height: 35px;
  line-height: 35px;
}
/*激活标签底部蓝色
.header_tag .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #409eff;
}*/
.el-main {
  background: #f2f2f2;
  padding: 10px;
  overflow: hidden;
}
.el-main > div {
  border-radius: 5px;
  height: calc(100vh - 70px);
  background: #fff;
}
.el-main > div > div {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 10px;
}
.logo_nav {
  height: 50px;
  width: 200px;
  overflow: hidden;
  text-align: center;
  transition: width 0.5s;
}
.logo_nav img {
  height: 100%;
}
.logo_sub_nav {
  height: 50px;
  width: 64px;
  overflow: hidden;
  text-align: center;
  transition: width 0.5s;
}
.logo_sub_nav img {
  height: 100%;
}
.photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
/*一级菜单 调度中心 小icon */
i.el-icon-c-scale-to-original {
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
}

/*.el-popover {
  min-width: 94px !important;
}*/

.fa-phone-volume {
  animation: move 1.5s 0s infinite;
  -webkit-animation: move 1.5s 0s infinite;
  transform-origin: bottom;
  -webkit-transform-origin: bottom;
  color: red;
  font-size: 19px;
}

@keyframes move {
  0%,
  65% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  70% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  75% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  80% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  85% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  90% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  95% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@import url('//unpkg.com/element-ui@2.15.7/lib/theme-chalk/index.css');
@-webkit-keyframes move {
  0%,
  65% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  70% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  75% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  80% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  85% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  90% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  95% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

.el-message-box {
  max-height: 80vh;
  overflow-y: auto !important;
}
/* 菜单 */
.nav-icon {
  min-width: 80px;
  > i {
    font-size: 18px;
    vertical-align: middle;
    cursor: pointer;
    padding: 5px 5px 5px 15px;
    &:hover {
      color: #409eff;
    }
  }
}
.nav-drawer {
  margin-top: 50px !important;
  .el-drawer {
    background-color: #f2f2f2;
    .el-drawer__body {
      display: flex;
      overflow: hidden;
      > .el-menu {
        overflow-y: auto;
        background-color: #f2f2f2;
        width: 300px;
        padding: 8px;
        border-right: none;

        > .el-submenu,
        > .el-menu-item {
          background-color: #fff;
          margin-bottom: 6px;
          border-radius: 4px;
          overflow: hidden;
          .el-submenu__title {
            height: 50px;
            line-height: 50px;
            padding-left: 15px !important;
          }
          li.el-menu-item {
            font-size: 13px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
            width: 50%;
            text-align: center;
            padding: 0;
            padding-left: 0 !important;
            min-width: auto;

            > span {
              padding: 5px;
              border-radius: 4px;
            }
          }
        }
      }
      > .submenu {
        flex: 1;
        margin: 8px 8px 8px 0;
        padding: 8px;
        background: #fff;
        border-radius: 4px;
        .submenu-item {
          padding-left: 6px !important;
          font-size: 13px;
          height: 40px;
          line-height: 40px;
          &:hover {
            background-color: #ecf5ff;
          }
        }
      }
    }
  }
  .el-drawer__header {
    display: none !important;
  }
}
.nav-drawer-500 {
  .el-drawer {
    width: 500px !important;
  }
}
.nav-drawer-auto {
  .el-drawer {
    width: auto !important;
  }
}
</style>

<style scoped lang="scss">
.el-popover__reference {
  display: flex;
  align-items: center;
}
.el-divider {
  z-index: -1;
}
.submenu-item-image {
  display: flex;
  padding: 0 !important;
  height: 60px !important;
  > img {
    flex: 1;
    padding: 0;
  }
  > span {
    display: none;
  }
}

$tab-height: 40px;
$active-color: #f2f2f2;
$default-color: #ffffff;
$primary-color: #1989fa;

.tab-list {
  display: flex;
  position: relative;
  z-index: 10;
  border-radius: 12px 12px 0 0;
  background-color: $default-color;
  height: 80%;

  width: 100%;
  max-width: 100%;
  padding: 0px 10px;
  .tab-item.active {
    position: relative;
    opacity: 1;
    background: #f2f2f2;
    border-radius: 13px 13px 0 0;
    box-shadow: 13px 13px 0 $active-color, -13px 13px 0 0 $active-color;
    font-weight: bolder;
  }
  .tab-item.active::before,
  .tab-item.active::after {
    content: '';
    position: absolute;
    bottom: -4px;
    width: 13px;
    height: $tab-height;
    background: $default-color;
    z-index: 1;
  }

  .tab-item.active::before {
    left: -13px;
    border-bottom-right-radius: 13px;
  }

  .tab-item.active::after {
    right: -13px;
    border-bottom-left-radius: 13px;
  }

  .ContextualMenu {
    position: fixed;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    color: #fff;
    background-color: #303133;
    border-radius: 5px;
    padding: 5px 2px;
    font-size: 14px;
    z-index: 100;
    div {
      border-radius: 5px;
      padding: 1px 10px;
      margin: 5px 4px;
    }
    div:hover {
      cursor: pointer;
      background-color: $primary-color;
    }
  }
}
.tab-item {
  cursor: default;
  max-width: 160px;
  flex: 1;
  height: $tab-height;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: $primary-color;
  opacity: 0.7;
  position: relative;
  padding: 0px 10px;
  margin: 0px 3px;
  position: relative;
  .tabName {
    width: 60%;
    max-width: 60%;
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
    mask-image: linear-gradient(to right, black 90%, transparent);
    -webkit-mask-image: linear-gradient(to right, black 90%, transparent);
    overflow: hidden; /* 隐藏溢出部分 */
    white-space: nowrap; /* 防止换行 */
  }
  .closeIcon {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    height: 13px;
    width: 13px;
    font-size: 12px;
    line-height: 13px;
    vertical-align: middle;
    z-index: 10;
  }
  .closeIcon:hover {
    height: 16px;
    width: 16px;
    line-height: 16px;
    color: #fff;
    background-color: #409eff;
  }
}
.tab-item-hover {
  height: 40px;
  border-radius: 13px;
  background: $active-color;
  z-index: 10;

  opacity: 1;
  font-weight: bolder;
}
</style>
<style scoped>
::v-deep .rich-text-container {
  p {
    margin: 1em 0;
    line-height: 1.5;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 1em 0;
    font-weight: bold;
  }

  ul,
  ol {
    margin: 1em 0;
    padding-left: 2em;
  }

  li {
    margin: 0.5em 0;
    list-style: auto;
  }

  blockquote {
    margin: 1em 0;
    padding: 0.5em 1em;
    border-left: 4px solid #ccc;
    background-color: #f9f9f9;
  }

  code {
    padding: 0.2em 0.4em;
    background-color: #f5f5f5;
    border-radius: 3px;
  }

  pre {
    margin: 1em 0;
    padding: 1em;
    background-color: #f5f5f5;
    border-radius: 3px;
    overflow-x: auto;
  }

  table {
    border-collapse: collapse;
    margin: 1em 0;
    width: 100%;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 0.5em;
  }

  th {
    background-color: #f5f5f5;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    color: #1890ff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
